import React from 'react';
import LocationTemplate from './LocationTemplate';

const ClaytonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Clayton"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27520", "27527"]}
      latitude={35.6507}
      longitude={-78.4564}
      population={26701}
      historicalFact="Originally called Stallings' Station, renamed after Senator John M. Clayton of Delaware."
      nearbyTowns={[
        "Raleigh, NC",
        "Garner, NC",
        "Smithfield, NC",
        "Knightdale, NC",
        "Selma, NC",
        "Four Oaks, NC",
        "Archer Lodge, NC",
        "Wendell, NC"
      ]}
    />
  );
};

export default ClaytonPage;